import { render } from "./PaymentGateway.vue?vue&type=template&id=3fcc3930"
import script from "./PaymentGateway.vue?vue&type=script&lang=js"
export * from "./PaymentGateway.vue?vue&type=script&lang=js"

import "./PaymentGateway.vue?vue&type=style&index=0&id=3fcc3930&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__